module.exports = __webpack_public_path__ + "static/media/400073_02.28ce26e0.png";